module.exports = "https://assets.calmac.co.uk/scripts/apps/site-services/1.10/img/accordionArrow.svg";